// src/components/more/MyChildren.js
import React, { useState } from 'react';
import { ChevronLeft, UserCircle } from 'lucide-react';
import { useAtom } from 'jotai';
import { appConstants, childList } from '../../atomstore/store';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const MyChildren = () => {
    const navigate = useNavigate();
    const [imageError, setImageError] = useState(false);
    const [constants] = useAtom(appConstants)
    const DEFAULT_FORMAT = "MMM DD, YYYY";
    const getFullPath = (constants, path) => {
        let imgString = "";
        if (typeof path === "string" && path.startsWith("https")) {
            imgString = path;
        } else if (typeof path === "string" && path.length === 0) {
            imgString = path;
        } else {
            imgString = constants?.ImagePath + path;
        }
        return imgString;
    };

    const [child] = useAtom(childList)
    return (
        <div className="">
            {/* <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800">My Children</h2>
            </div> */}

            <div className="p-4 space-y-4">
                <div className="bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2">Children Details</h3>
                    <p className="text-cyan-100 text-sm">Complete information about your children</p>
                </div>

                {child.map((child, idx) => (
                    <div key={idx} className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                        <div className="flex items-start space-x-3 mb-3">
                            <div className="w-16 h-16 bg-gradient-to-br from-cyan-100 to-blue-100 rounded-xl flex items-center justify-center text-3xl">
                                {
                                    child?.child_photo &&
                                        child?.child_approved_status !== "Inactive" &&
                                        !imageError ? (
                                        <div className="flex justify-center my-4">
                                            <img
                                                className="h-16 w-16 rounded-full object-cover border-4"
                                                src={getFullPath(constants, child?.child_photo)}
                                                alt={child?.name}
                                                onError={() => setImageError(true)}   // fallback trigger
                                            />
                                        </div>
                                    ) : (
                                        <div className="flex justify-center my-4">
                                            <div className="h-16 w-16 rounded-full  
                            flex items-center justify-center text-gray-600 text-xl font-bold">
                                                <UserCircle size={40} />
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="flex-1">
                                <h4 className="font-bold text-gray-800 text-lg">{child?.name} {child?.last_name}</h4>
                                <p className="text-sm text-gray-500">{child?.length} ({child?.program_time_slots})</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <p className="text-xs text-gray-500">Class</p>
                                <p className="text-sm font-medium text-gray-800">{child?.["room.name"]}</p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-500">Admission ID</p>
                                <p className="text-sm font-medium text-gray-800">{child?.id}</p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-500">Date of Birth</p>
                                <p className="text-sm font-medium text-gray-800"> {moment(child?.date_of_birth).format(DEFAULT_FORMAT)}</p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-500">Blood Group</p>
                                <p className="text-sm font-medium text-gray-800">{child?.blood_group}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MyChildren;